@if (vehicle(); as vehicle) {
  @let generalInformation = vehicle.generalInformation;

  @let state = generalInformation.state;
  <onyx-badge
    [color]="state === FleetState.ACTIVE ? 'light-green' : 'light-gray'"
    [size]="20"
  >
    {{ `${DictionaryCode.FLEET_STATE}.${state}` | translate }}
  </onyx-badge>

  <span>·</span>

  {{
    `${isVehicle() ? DictionaryCode.VEHICLE_CATEGORY : DictionaryCode.TRAILER_CATEGORY}.${vehicle.generalInformation.category}`
      | translate
  }}

  @if (generalInformation.type; as type) {
    <span>·</span>

    {{ `${DictionaryCode.VEHICLE_TYPE}.${type}` | translate }}
  }

  <span>·</span>

  <span>{{ generalInformation.make }} {{ generalInformation.model }}</span>

  <span>·</span>

  @let totalDistance =
    ('telemetry' in vehicle ? vehicle.telemetry?.totalDistance : null) ??
    vehicle.generalInformation.initialMileage;
  @if (totalDistance != null) {
    {{ totalDistance | onyxDistance }}

    <span>·</span>
  }

  {{ generalInformation.manufactureYear }}

  @if (vehicle.fuelTankCapacity?.fuelType; as fuelType) {
    <span>·</span>

    {{ `${DictionaryCode.FUEL_TYPE}.${fuelType}` | translate }}
  }
}
